import React from 'react';
import { Lightbulb, AlertTriangle, TrendingUp } from 'lucide-react';

/**
 * StudyInsightCallout — Destaque de insight dentro de um estudo
 *
 * Usado entre blocos de gráfico para chamar atenção para uma descoberta-chave.
 *
 * Props:
 *   variant  — 'insight' (amarelo) | 'warning' (vermelho) | 'positive' (verde)
 *   title    — Título do callout (opcional)
 *   children — Conteúdo textual do insight
 */

const VARIANTS = {
  insight: {
    bg: '#fffbeb',
    border: '#fbbf24',
    icon: <Lightbulb className="w-5 h-5" />,
    iconColor: '#f59e0b',
    defaultTitle: 'Descoberta-chave',
  },
  warning: {
    bg: '#fef2f2',
    border: '#f87171',
    icon: <AlertTriangle className="w-5 h-5" />,
    iconColor: '#ef4444',
    defaultTitle: 'Atenção',
  },
  positive: {
    bg: '#ecfdf5',
    border: '#34d399',
    icon: <TrendingUp className="w-5 h-5" />,
    iconColor: '#10b981',
    defaultTitle: 'Tendência positiva',
  },
};

const StudyInsightCallout = ({ variant = 'insight', title, children }) => {
  const v = VARIANTS[variant] || VARIANTS.insight;

  return (
    <div
      className="rounded-2xl px-6 py-5 my-6 border-l-4"
      style={{
        backgroundColor: v.bg,
        borderLeftColor: v.border,
      }}
    >
      <div className="flex items-start gap-3">
        <span style={{ color: v.iconColor }} className="mt-0.5 flex-shrink-0">
          {v.icon}
        </span>
        <div>
          <p className="font-bold text-gray-900 text-sm mb-1">{title || v.defaultTitle}</p>
          <div className="text-sm text-gray-700 leading-relaxed">{children}</div>
        </div>
      </div>
    </div>
  );
};

export default StudyInsightCallout;
